import React__default from 'react';
import { Author as Author$2 } from './Author.styles.js';

var Author = function Author(_ref) {
  var date = _ref.date,
    fullName = _ref.fullName;
  return /*#__PURE__*/React__default.createElement(Author$2, null, fullName && fullName, /*#__PURE__*/React__default.createElement("div", {
    className: "date-and-readtime"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "publish-date"
  }, date)));
};
var Author$1 = Author;

export { Author$1 as default };
//# sourceMappingURL=index.js.map
